// extracted by mini-css-extract-plugin
module.exports = {"content":"CloseAccount__content--2wu","description":"CloseAccount__description--2dd","button":"CloseAccount__button--2Br","error":"CloseAccount__error--2m5"};